import React, { useState, useEffect } from "react";
import { Input, Card, Checkbox } from "antd";
import StyledButton from "../../components/styledButton";
import Divider from "../../components/divider";
import styles from "./style.module.scss";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import logo from "../../assets/images/branding/CREDITZ-WHITE.png";

function Home(props) {
    return (
        <div className={styles.mainComponent}>
            <img src={logo} alt="Logo" className={styles.logo} />

            <div className={styles.buttons}>
                <Link to="/Login">
                    <StyledButton title="Login" />
                </Link>

                <Divider className={styles.divider} />
                <Link to="/signUp">
                    <StyledButton type={true} title="Create an account" />
                </Link>
            </div>
        </div>
    );
}

export default withRouter(Home);
